import { render, staticRenderFns } from "./contact-relation-table.vue?vue&type=template&id=3904619a&scoped=true&"
import script from "./contact-relation-table.ts?vue&type=script&lang=ts&"
export * from "./contact-relation-table.ts?vue&type=script&lang=ts&"
import style0 from "./contact-relation-table.scss?vue&type=style&index=0&id=3904619a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3904619a",
  null
  
)

export default component.exports